module.exports = __webpack_public_path__ + "img/ic_arrowup.f68e49b0.svg";